export default __webpack_public_path__ + "connect.svg?2d2f8e3ead710f6cfda6613b4d9e10f3";